import { encrypt } from "@/javascript/jsencrypt";
/** 用户信息操作
 */
const accountCtl = {
  /** 修改密码
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  updatePass: function(_this, url) {
    var oldPass = _this.creatFrom.oldPass;
    var pass = _this.creatFrom.pass;
    // 等保三级
    // if(!_this.loginpromptDialogVisible){
    //   if (JSON.parse(sessionStorage.getItem('encryptEnabled'))) {
    //     oldPass = encrypt(oldPass)
    //     pass = encrypt(pass)
    //   }
    // }

    _this
      .$axios({
        method: "post",
        url: url,
        data: {
          uId: JSON.parse(sessionStorage.getItem("userInfo")).uId,
          oldPassword: oldPass,
          newPassword: pass
          // 等保三级
          // encryptEnabled:JSON.parse(sessionStorage.getItem('encryptEnabled'))
        },
        headers: {
          Authorization: sessionStorage.getItem("token")
        }
      })
      .then(function(res) {
        if (res.data.code === 200) {
          if (res.data.data !== 1) {
            _this.$message({
              message: res.data.data.message,
              type: "error"
            });
          } else {
            sessionStorage.clear();
            _this
              .$alert("密码修改成功！点击确定重新登录平台！", "提示", {
                confirmButtonText: "确定",
                showClose: false,
                closeOnClickModal: false
              })
              .then(() => {
                _this.$router.push("/");
                _this.loginpromptDialogVisible = false;
              });
          }
        } else {
          _this.$message({
            message: res.data.message,
            type: "error"
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  /** 重置密码（123456）
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  resetPass: function(_this, url, uId) {
    _this
      .$axios({
        method: "get",
        url: url,
        params: {
          uId: uId
        },
        headers: {
          Authorization: sessionStorage.getItem("token")
        }
      })
      .then(function(res) {
        if (res.data.code === 200) {
          _this.$message({
            message: "重置密码成功！",
            type: "success"
          });
        } else {
          console.log(res);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
};
export default accountCtl;



// WEBPACK FOOTER //
// ./src/javascript/function/accountFun.js